var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyModeoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 20.5V6.5H1.5V5.5H4.5V3H1.5V2H4.5H5.5H17.5H18.5H22V3H18.5V5.5H22V6.5H18.5V20.5C18.5 21.3284 17.8284 22 17 22H6C5.17157 22 4.5 21.3284 4.5 20.5ZM17.5 3H5.5V5.5H17.5V3ZM5.5 20.5V6.5H17.5V20.5C17.5 20.7761 17.2761 21 17 21H6C5.72386 21 5.5 20.7761 5.5 20.5ZM10.75 12.5V15.5H12.25V12.5H14.25L11.5 9.5L8.75 12.5H10.75ZM21.25 17.5C21.6642 17.5 22 17.1642 22 16.75C22 16.3358 21.6642 16 21.25 16C20.8358 16 20.5 16.3358 20.5 16.75C20.5 17.1642 20.8358 17.5 21.25 17.5ZM22 14.25C22 14.6642 21.6642 15 21.25 15C20.8358 15 20.5 14.6642 20.5 14.25C20.5 13.8358 20.8358 13.5 21.25 13.5C21.6642 13.5 22 13.8358 22 14.25ZM21.25 12.5C21.6642 12.5 22 12.1642 22 11.75C22 11.3358 21.6642 11 21.25 11C20.8358 11 20.5 11.3358 20.5 11.75C20.5 12.1642 20.8358 12.5 21.25 12.5ZM22 9.25C22 9.66421 21.6642 10 21.25 10C20.8358 10 20.5 9.66421 20.5 9.25C20.5 8.83579 20.8358 8.5 21.25 8.5C21.6642 8.5 22 8.83579 22 9.25Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyModeoff);
export default __webpack_public_path__ + "static/media/privacy-mode off.50686777c1ced4bc66d4bb689f0e1c30.svg";
export { ForwardRef as ReactComponent };